// @flow
import React from 'react';
import Banner from '../components/Banner';
import { Link } from 'react-router';

const NotFound = () => (
  <div>
    <Banner title="404 Not Found" image="mailbox" />

    <div className="container text-center">
      <p>
        <strong>We can't seem to find the page you're looking for.</strong>
      </p>
      <p>
        <Link to={'/'}>Go to Dashboard</Link>
      </p>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound.js